module.exports = __webpack_public_path__ + "img/AR.97d7ea65.svg";